'use es6';

import PropTypes from 'prop-types';
import ImmutableModel from 'DesignData/models/ImmutableModel';
import * as EditorErrorTypes from 'DesignData/enums/EditorErrorTypes';
/**
 * @property {String} type, one of (ERROR, WARNING, INFO, SUCCESS)
 * @property {String} message
 * @property {String} messageLink -href for link
 * @property {Bool} messageLinkExternal -is the link external
 * @property {Function} onMessageClick
 *
 * @property {String} helpMessage
 * @property {String} helpMessageLink -href for link
 * @property {Bool} helpMessageLinkExternal -is the link external
 * @property {Function} onHelpMessageClick
 */

export default class EditorError extends ImmutableModel {
  constructor(props) {
    const {
      type
    } = props;

    if (!EditorErrorTypes[type]) {
      throw new Error(`Error type must one of of ${Object.keys(EditorErrorTypes || {})}`);
    }

    return super(props);
  }

}
EditorError.REQUIRED_FIELDS = ['type', 'message'];
EditorError.editorErrorPropType = PropTypes.instanceOf(EditorError);
EditorError.editorErrorArrayPropType = PropTypes.arrayOf(EditorError.editorErrorPropType);